export default {
    animal_evacuation: {
        name: "Animal Evacuation",
        url: "sarcop_search_human_interactions_that_do_not_need_follow_up_by_default/animal_evacuation",
    },
    assisted: {
        name: "Assisted",
        url: "sarcop_search_human_interactions_that_do_not_need_follow_up_by_default/assisted",
    },
    evacuated: {
        name: "Evacuated",
        url: "sarcop_search_human_interactions_that_do_not_need_follow_up_by_default/evacuated",
    },
    human_remains_removed: {
        name: "Human Remains Removed",
        url: "sarcop_search_human_interactions_that_do_not_need_follow_up_by_default/human_remains_removed",
    },
    rescued: {
        name: "Rescued",
        url: "sarcop_search_human_interactions_that_do_not_need_follow_up_by_default/rescued",
    },
    searched_per_rules_of_engagement: {
        name: "Searched per Rules Of Engagement",
        url: "sarcop_search_human_interactions_that_do_not_need_follow_up_by_default/searched_per_rules_of_engagement",
    },
    shelter_in_place: {
        name: "Shelter In Place",
        url: "sarcop_search_human_interactions_that_do_not_need_follow_up_by_default/shelter_in_place",
    },
}
